import React, { Component } from 'react';
import { compose } from 'recompose';
import { translate } from '../../utils/translateUtils';

// import fbbw from './static/img/social/fbbw.svg';
// import fbcolored from './static/img/social/fbcolored.svg';
import twbw from './static/img/social/twitterbw.svg';
import twcolored from './static/img/social/twittercolored.svg';
// import vkbw from './static/img/social/vkbw.svg';
// import vkcolored from './static/img/social/vkcolored.svg';
import ytbw from './static/img/social/youtubebw.svg';
import ytcolored from './static/img/social/youtubecolored.svg';
import telegrambw from './static/img/social/telegrambw.svg';
import telegramcolored from './static/img/social/telegramcolored.svg';

import './social-buttons.scss';

const enhance = compose(translate);

class SocialButtons extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className={'media media_type_' + this.props.type}>
        <a
          href="https://www.youtube.com/user/theunitedtraders"
          target="_blank"
          rel="noopener noreferrer"
          className={
            'media__item media__item_type_' +
            this.props.type +
            ' social social_type_' +
            this.props.type
          }
        >
          <img
            src={ytbw}
            className={'social__image social__image_youtube social__image_type_' + this.props.type}
            alt=""
          />
          <img
            src={ytcolored}
            className={
              'social__image social__image_youtube social__image_hovered social__image_type_' +
              this.props.type
            }
            alt=""
          />
          <span
            className={'social__name social__name_youtube social__name_type_' + this.props.type}
          >
            YouTube
          </span>
        </a>
        {/* <a
          href="https://www.facebook.com/unitedtraders"
          target="_blank"
          rel="noopener"
          className={
            'media__item media__item_type_' +
            this.props.type +
            ' social social_type_' +
            this.props.type
          }
        >
          <img
            src={fbbw}
            className={'social__image social__image_fb social__image_type_' + this.props.type}
            alt=""
          />
          <img
            src={fbcolored}
            className={
              'social__image social__image_fb social__image_hovered social__image_type_' +
              this.props.type
            }
            alt=""
          />
          <span className={'social__name social__name_fb social__name_type_' + this.props.type}>
            Facebook
          </span>
        </a> */}
        {/* <a
          href="http://vk.com/unitedtraders"
          target="_blank"
          rel="noopener"
          className={
            'media__item media__item_type_' +
            this.props.type +
            ' social social_type_' +
            this.props.type
          }
        >
          <img
            src={vkbw}
            className={'social__image social__image_vk social__image_type_' + this.props.type}
            alt=""
          />
          <img
            src={vkcolored}
            className={
              'social__image social__image_vk social__image_hovered social__image_type_' +
              this.props.type
            }
            alt=""
          />
          <span className={'social__name social__name_vk social__name_type_' + this.props.type}>
            {t('VK')}
          </span>
        </a> */}
        <a
          href="https://twitter.com/UnitedTraders_1"
          target="_blank"
          rel="noopener noreferrer"
          className={
            'media__item media__item_type_' +
            this.props.type +
            ' social social_type_' +
            this.props.type
          }
        >
          <img
            src={twbw}
            className={'social__image social__image_twitter social__image_type_' + this.props.type}
            alt=""
          />
          <img
            src={twcolored}
            className={
              'social__image social__image_twitter social__image_hovered social__image_type_' +
              this.props.type
            }
            alt=""
          />
          <span
            className={'social__name social__name_twitter social__name_type_' + this.props.type}
          >
            Twitter
          </span>
        </a>
        <a
          href={t('telegram social link')}
          target="_blank"
          rel="noopener"
          className={
            'media__item media__item_type_' +
            this.props.type +
            ' social social_type_' +
            this.props.type
          }
        >
          <img
            src={telegrambw}
            className={'social__image social__image_tg social__image_type_' + this.props.type}
            alt=""
          />
          <img
            src={telegramcolored}
            className={
              'social__image social__image_tg social__image_hovered social__image_type_' +
              this.props.type
            }
            alt=""
          />
          <span className={'social__name social__name_tg social__name_type_' + this.props.type}>
            Telegram
          </span>
        </a>
      </div>
    );
  }
}

export default enhance(SocialButtons);



// WEBPACK FOOTER //
// ./src/blocks/socialButtons/SocialButtons.js